import styled from 'styled-components';

import { breakpoints } from 'definitions'

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
gap: 1rem;
    ${breakpoints.phablet} {
        svg{
            width: 20px;
            height: 20px;
        }
    }

    ${breakpoints.laptop} {
        /* En el header no hay lugar para las redes junto al botón del evento;
           siguen disponibles en el footer. */
        display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
    }
`;
